import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=01672243&"
import script from "@/components/curriculum/Curriculum.ts?vue&type=script&lang=ts&"
export * from "@/components/curriculum/Curriculum.ts?vue&type=script&lang=ts&"
import style0 from "@/components/curriculum/curriculum.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports